// src/store/slices/moduleSlice.js
import { createSlice } from "@reduxjs/toolkit";

const COMPANY_SCOPED_ROLES = ["super.admin"];
const PLATFORM_SCOPED_ROLES = ["viso.super.admin"];

// normalize "Super Admin" -> "super.admin", "VISO Super Admin" -> "viso.super.admin"
const normalizeRole = (roleName) =>
  (roleName || "").trim().toLowerCase().replace(/\s+/g, ".");

const getScopeForRole = (roleName) => {
  const normalized = normalizeRole(roleName);
  if (PLATFORM_SCOPED_ROLES.includes(normalized)) return "PLATFORM";
  if (COMPANY_SCOPED_ROLES.includes(normalized)) return "COMPANY";
  return "SITE";
};

const initialState = {
  roleName: localStorage.getItem("role_name") || null,
  siteType: localStorage.getItem("site_type") || "YARD",
  availableModules: JSON.parse(localStorage.getItem("available_modules") || "[]"),
  activeModule: localStorage.getItem("active_module") || "YARD",
};

const moduleSlice = createSlice({
  name: "module",
  initialState,
  reducers: {
    initModuleFromLogin: (state, action) => {
      const { roleName, siteType, availableModules } = action.payload;
      state.roleName = roleName;
      state.siteType = siteType || "YARD";
      state.availableModules = availableModules?.length
        ? availableModules
        : [siteType || "YARD"];
      state.activeModule = siteType || "YARD";

      localStorage.setItem("role_name", state.roleName);
      localStorage.setItem("site_type", state.siteType);
      localStorage.setItem("available_modules", JSON.stringify(state.availableModules));
      localStorage.setItem("active_module", state.activeModule);
    },
    setActiveModule: (state, action) => {
      state.activeModule = action.payload;
      localStorage.setItem("active_module", action.payload);
    },
    setAvailableModulesForCompany: (state, action) => {
      state.availableModules = action.payload;
      localStorage.setItem("available_modules", JSON.stringify(action.payload));
      if (!action.payload.includes(state.activeModule)) {
        state.activeModule = action.payload[0] || "YARD";
        localStorage.setItem("active_module", state.activeModule);
      }
    },
  },
});

export const { initModuleFromLogin, setActiveModule, setAvailableModulesForCompany } =
  moduleSlice.actions;

export const selectScope = (state) => getScopeForRole(state.module.roleName);
export const selectIsYard = (state) => state.module.activeModule === "YARD";
export const selectIsWarehouse = (state) => state.module.activeModule === "WAREHOUSE";
export const selectIsPlant = (state) => state.module.activeModule === "PLANT";
export const selectCanSwitchModules = (state) =>
  getScopeForRole(state.module.roleName) !== "SITE" &&
  state.module.availableModules.length > 1;

export default moduleSlice.reducer;